// 🔒
export const privacyPolicySections = [
  {
    id: 1,
    title: "Introduction",
    content: [
      "This Privacy Policy explains how we collect, use, and protect personal information when you use our website, mobile application, and related services.",
      "By using our platform, you agree to the practices described in this Privacy Policy."
    ]
  },
  {
    id: 2,
    title: "Information We Collect",
    content: [
      "We may collect personal information you provide directly, such as your name, email address, account details, and any information submitted through contact forms or trainer application forms.",
      "We may also collect usage information, device information, app interaction data, and other technical information needed to improve the platform and provide our services."
    ]
  },
  {
    id: 3,
    title: "How We Use Information",
    content: [
      "We use collected information to operate the app and website, provide user support, improve features, manage purchases, communicate with users or trainers, and maintain the security and integrity of the platform.",
      "We may also use information to analyze product performance, understand user behavior, and improve the overall user experience."
    ]
  },
  {
    id: 4,
    title: "Trainer Collaboration Data",
    content: [
      "If you apply to collaborate as a trainer, we may collect information you submit through forms or direct communication, including your name, contact details, professional background, and program information.",
      "This information is used only for evaluating collaboration opportunities, onboarding trainers, and managing the professional relationship."
    ]
  },
  {
    id: 5,
    title: "Payments and Purchases",
    content: [
      "If the platform offers paid content, certain payment-related information may be processed through third-party payment providers or app marketplace providers such as Apple App Store or Google Play.",
      "We do not store full payment card details unless explicitly stated through a secure payment provider workflow."
    ]
  },
  {
    id: 6,
    title: "How We Share Information",
    content: [
      "We do not sell personal information to third parties.",
      "We may share limited information with trusted service providers or technical partners who help us operate the app, host content, process payments, analyze usage, or provide customer support, but only where necessary."
    ]
  },
  {
    id: 7,
    title: "Data Retention",
    content: [
      "We retain personal information only for as long as necessary to provide services, comply with legal obligations, resolve disputes, and enforce agreements.",
      "Retention periods may vary depending on the type of data and the purpose for which it was collected."
    ]
  },
  {
    id: 8,
    title: "Data Security",
    content: [
      "We take reasonable technical and organizational measures to protect personal information from unauthorized access, loss, misuse, or disclosure.",
      "However, no digital system can be guaranteed to be completely secure."
    ]
  },
  {
    id: 9,
    title: "Your Rights",
    content: [
      "Depending on your location and applicable law, you may have rights related to your personal information, including the right to access, correct, delete, or restrict certain uses of your data.",
      "You may also have the right to contact us regarding questions about how your personal information is handled."
    ]
  },
  {
    id: 10,
    title: "Children’s Privacy",
    content: [
      "Our platform is not intended for children unless explicitly stated otherwise, and we do not knowingly collect personal information from children without appropriate legal basis or parental consent where required."
    ]
  },
  {
    id: 11,
    title: "Third-Party Services",
    content: [
      "The app and website may include links to third-party platforms or services, such as app stores, forms, analytics tools, or embedded content. Their privacy practices are governed by their own policies."
    ]
  },
  {
    id: 12,
    title: "Changes to This Policy",
    content: [
      "We may update this Privacy Policy from time to time to reflect changes in the platform, legal requirements, or operational practices.",
      "When we make important updates, we may revise the effective date and publish the updated version on the website."
    ]
  },
  {
    id: 13,
    title: "Contact",
    content: [
      "If you have questions about this Privacy Policy or want to contact us regarding personal data matters, you can reach out through the contact details or support channels provided on the platform."
    ]
  }
];
// 🔒